import { BusinessManagerBusiness } from '@marketing-milk/interfaces'
import Store from 'app/redux/store'
import { bindActions } from 'redux-zero/utils'

const Basic = bindActions(
  () => ({
    // Update single column
    update: (state, key: string, value: any) => ({
      pages: {
        ...state.pages,
        business: {
          ...state.pages.business,
          main: {
            ...state.pages.business.main,
            [key]:
              (key === 'fb_dataset_id' ||
                key === 'fb_page_id' ||
                key === 'instagram_id' ||
                key === 'offline_event_set_id') &&
              !value
                ? null
                : value,
          },
        },
      },
    }),
    // The panel's display-only Facebook info (fb_business_info, fb_asset_owner_info, fb_person_info) and its
    // unsaved-changes state (fb_pending_fields): resolved
    // server-side on load, never sent back on save. Kept here as the panel changes it, so leaving the tab and
    // coming back (which remounts the panel) shows what was just assigned rather than the load-time state.
    setFacebookDisplayInfo: (
      state,
      patch: Partial<
        Pick<
          BusinessManagerBusiness,
          'fb_business_info' | 'fb_asset_owner_info' | 'fb_person_info' | 'fb_pending_fields'
        >
      >
    ) => ({
      pages: {
        ...state.pages,
        business: { ...state.pages.business, ...patch },
      },
    }),
    // Adds to fb_pending_fields from the store's current state, so back-to-back assigns from one render's
    // callbacks (the Fix dialog moving both fields) don't overwrite each other.
    markFacebookFieldsPending: (state, fields: string[]) => ({
      pages: {
        ...state.pages,
        business: {
          ...state.pages.business,
          fb_pending_fields: Array.from(
            new Set([...(state.pages.business.fb_pending_fields ?? []), ...fields])
          ),
        },
      },
    }),
  }),
  Store
)

export default Basic
